<pw-view-title>{{(pos$ | async)?.NAME}}</pw-view-title>

<pw-view-actions>
  <button mat-icon-button (click)="openSearchDialog()">
    <mat-icon>find_in_page</mat-icon>
  </button>
  <button mat-icon-button (click)="openCreatePlannedDeliveryBottomsheet()">
    <mat-icon>add</mat-icon>
  </button>

</pw-view-actions>

<mat-tab-group (selectedTabChange)="onTabSelectionChanged($event)">
  <mat-tab label="{{'orders.deliveries.plannedDeliveries.plannedDeliveries' | translate}}">

    <mat-accordion style="padding: 8px">
      <mat-expansion-panel expanded="true"
                           [ngStyle]="{'background-color' : (partsstockExt | async) > 0 ? '#ffcdd2' : ''}">
        <mat-expansion-panel-header
          style="font-weight: bold">{{'orders.deliveries.plannedDeliveries.externalStock' | translate}}</mat-expansion-panel-header>
        <div class="ps-grid-2-col">
          <div style="justify-self: center">{{'orders.deliveries.plannedDeliveries.qsParts' | translate}}</div>
          <div style="justify-self: center">{{'orders.deliveries.plannedDeliveries.makeoverParts' | translate}}</div>
          <div style="justify-self: center">{{partsstockExt | async}}</div>
          <div style="justify-self: center">{{partsstockUm | async}}</div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header
          style="font-weight: bold">{{'orders.deliveries.plannedDeliveries.filterDeliveries' | translate}}</mat-expansion-panel-header>
        <div class="ps-flex-container-col" style="padding-top: 8px">

          <mat-form-field style="justify-self: center" appearance="fill">
            <mat-label>{{'orders.deliveries.plannedDeliveries.search' | translate}}</mat-label>
            <input type="text" matInput placeholder="Filter" [formControl]="searchFormControl">
          </mat-form-field>

          <div class="status-container ps-grid-3-col">
            <div>{{'orders.deliveries.plannedDeliveries.planned' | translate}}</div>
            <div>{{'orders.deliveries.plannedDeliveries.delivered' | translate}}</div>
            <div>{{'orders.deliveries.plannedDeliveries.checked' | translate}}</div>
            <div>
              <mat-icon>functions</mat-icon>
              {{sumPlannedCount$ | async}}</div>
            <div>
              <mat-icon>functions</mat-icon>
              {{sumDeliveryCount$ | async}} (<span
              style="color: red; font-weight: bold">-{{sumRejectedCount$ | async}}</span>)
            </div>
            <div>
              <mat-icon>functions</mat-icon>
              {{sumConfirmedCount$ | async}}
            </div>
          </div>

        </div>
      </mat-expansion-panel>
    </mat-accordion>


    <mat-divider style="margin: 8px"></mat-divider>

    <ps-planned-delivery [deliveries]="deliveries$ | async" [isLoading]="deliveriesAreLoading$ | async"
                         [icons]="icons$ | async"
                         [pos]="pos">
    </ps-planned-delivery>
  </mat-tab>

  <mat-tab label="Chart">
    <div style="padding-top: 12px">
      <highcharts-chart *ngIf="!isChartLoading; else loadingChart" [Highcharts]="Highcharts"
                        [oneToOne]="true"
                        [options]="chartOptions"></highcharts-chart>
      <ng-template #loadingChart>
        {{'orders.deliveries.plannedDeliveries.chartLoading' | translate}}...
      </ng-template>
    </div>
  </mat-tab>

</mat-tab-group>
